// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"Usertooltip_toolTip_2HaCC"};